const checkGroupShow = function (categories, group, formContext = null) {
    if ("show_if" in group) {
        const f = findFieldByKey(categories, group.show_if.fieldKey, formContext);
        return checkCondition(f.value, group.show_if.operator, group.show_if.value);
    }
    return group.show;
}

const checkFieldShow = function (categories, field, formContext = null) {
    if ("show_if" in field) {
        const f = findFieldByKey(categories, field.show_if.fieldKey, formContext);
        return checkCondition(f.value, field.show_if.operator, field.show_if.value);
    }
    return field.show;
}

const checkFieldDisable = function (categories, field) {
    if ("disable_if" in field) {
        const f = findFieldByKey(categories, field.disable_if.fieldKey);
        return checkCondition(f.value, field.disable_if.operator, field.disable_if.value);
    }
    return false;
}

const findFieldByKey = function (categories, fieldKey, formContext = null) {
    let field = null;
    if (formContext != null) {
        const fieldResult = findFieldInFormByKey(fieldKey, formContext);
        if (fieldResult) field = fieldResult;
    } else {
        categories.forEach((c) =>
            c.sections.forEach((s) => {
                if (s.sectionType == "single") {
                    const fieldResult = findFieldInFormByKey(fieldKey, s.form);
                    if (fieldResult) field = fieldResult;
                }

                if (s.sectionType == "multiple") {
                    s.items.forEach((i) => {
                        const fieldResult = findFieldInFormByKey(fieldKey, i);
                        if (fieldResult) field = fieldResult;
                    });
                }
            })
        );
    }
    return field;
}

const findFieldInFormByKey = function (fieldKey, form) {
    let field = null;
    form.forEach((g) => {
        const fieldResult = g.fields.find((f) => f.fieldKey == fieldKey);
        if (fieldResult) field = fieldResult;
    });
    return field;
}

const checkCondition = function (lVal, op, rVal) {
    switch (op) {
        case "<":
            return lVal < rVal;

        case "<=":
            return lVal <= rVal;

        case ">":
            return lVal > rVal;

        case ">=":
            return lVal >= rVal;

        case "!=":
            return lVal != rVal;

        default:
            return lVal == rVal;
    }
}

export {
    checkGroupShow,
    checkFieldShow,
    checkFieldDisable,
    findFieldByKey,
    findFieldInFormByKey,
    checkCondition
};
